/**
 * Created by alex.y on 7/14/2017.
 */

import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../services/userService";
import { ConfigService } from "../../../services/configService";
import { ActivatedRoute, Router } from "@angular/router";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ResponseError } from "../../../objects/common/responseError";
import { Environment } from "../../../objects/common/configuration";

@Component({
    selector: 'google-login',
    templateUrl: './googleLogin.component.html',
    moduleId: module.id.toString()
})
export class GoogleLoginComponent implements OnInit {

    private accessToken: string;

    public errors: ResponseError[] = [];

    public constructor(private userService: UserService, private configService: ConfigService, private router: Router, public route: ActivatedRoute) {
    }

    public  ngOnInit(): void {
        let hash = location.hash;

        if (String.isNullOrEmpty(hash))
            return;

        if (!location.hash.split('access_token='))
            return;

        this.accessToken = location.hash.match(/access_token=([^&]*)&/)[1];

        if (!this.accessToken)
            return;

        this.userService.getExternalUserInfo(this.accessToken).then(resp => {
            Cookie.set(this.configService.config.ApiTokenCookieName, this.accessToken, 1, '/');
            Cookie.set(this.configService.config.UserCookieName, resp.Data.Id.toString(), 1, '/');
            this.router.navigate(["calculator/agent"]);
        });
    }

    /**
     * redirect user to google authorization
     */
    public login(): void {
        Cookie.delete(this.configService.config.ApiTokenCookieName);
        Cookie.delete(this.configService.config.UserCookieName);
        Cookie.delete(this.configService.config.UserAmazonCookieName);

        this.userService.prepareExternalLogin().then(x => {
            window.location.href =
                `${this.configService.config.ApiUrl}/api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=${this.configService.config.ApiUrl}` +
                `/api/Account/ExternalLogin&state=0eYM9Qg6Gu3Z8H3CqEQUfmI3i_XM59C-q5UUdAONOpw1`;
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/auth/googleLogin/googleLogin.component.ts